import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm4.197 7.47a.749.749 0 0 0-1.06 0l-3.915 3.913L7.53 9.692l-.084-.073a.75.75 0 0 0-.976 1.133l2.752 2.753 4.975-4.975.073-.084a.75.75 0 0 0-.073-.976z"
    }, null, -1)
  ])))
}
export default { render: render }